/**
 * This file is categorized as "Proprietary Framework Code"
 * and is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import {
	Icon,
	Row,
	Text,
} from 'native-base';
import {
	FontAwesome5,
} from '@expo/vector-icons';

export default function(props) {
	return <Row justifyContent="center" alignItems="center" my={2} w="100%">
				<Icon as={FontAwesome5} name="exclamation" color="red.500" size="xs" />
				<Text color="red.500">
					{props.children}
				</Text>
			</Row>;
}
